import { FontIcon } from '@intigral/shared';
import PlayVideoButton from '../../../../components/elements/PlayVideoButton';
import { ButtonTypes, COMPONENT_TYPES } from '../../../../config/constants';
import { checkShowLockIcon } from '../../../../helpers/vod';
import { useConfigurationSections } from '../../../../hooks/useConfiguration';
import useLanguage from '../../../../hooks/useLanguage';
import useShowPPvCta from '../../../../hooks/useShowPPvCta';
import useTimeToExpire from '../../../../hooks/useTimeToExpire';
import user from '../../../../helpers/user';
import { __ } from '../../../../translations';
import { useRentButtonTitle } from '../../../detail-overlay/hooks/useRentButtonTitle';

const PlayButton = ({ promotion, name, bookmarkedItem }) => {
    const { promoType } = promotion;
    const isTVChannel = promoType === 'CHANNEL' || promoType === 'LIVESTREAM';
    const isPPV = promoType === 'PPV';
    const isRoute = promoType === 'ROUTE';
    const isTvod = promotion?.isTvod;
    const { isShowBuyNowCta, isStreamingNow, isSubscribed, isRewind, isAvailableSoonCta } = useShowPPvCta(
        promotion?.ppvEvent || null
    );
    const { paidVsFree } = useConfigurationSections();
    const enableLockIcon = paidVsFree?.lockIconEnable || false;
    const isLocked = checkShowLockIcon(promotion?.subscriptionGuids ?? []) && enableLockIcon;

    const tvodList = user.getUserInfo()?.tvodList ?? [];
    const rentedTvod = tvodList.find(
        (item) => item.productGUID === promotion?.guid || item.productId === promotion?.productId
    );
    const isRented = !!rentedTvod?.expiryDate;
    const { hours = 0, minutes = 0 } = useTimeToExpire(rentedTvod?.expiryDate ?? null);
    const shouldShowRentButton = isTvod && !bookmarkedItem && (!isRented || (hours <= 0 && minutes <= 0));
    const tvodRentNowBtnText = useRentButtonTitle({ priceWithVat: promotion?.price });

    if (isPPV && isAvailableSoonCta) return null;

    const getButtonLabel = () => {
        if (bookmarkedItem) return __(`continue_watching`);
        if (isRoute) return __(`navigate_page`);
        if (isTVChannel) return __(`watch_now`);
        if (isPPV) {
            const { price, currency } = promotion?.ppvEvent || {};
            const hasPrice = price !== undefined && price !== null && price !== '';

            let key = 'ppv_watch_now';
            if (isStreamingNow && !isSubscribed) {
                key = hasPrice ? 'ppv_watch_now_price' : 'ppv_watch_now';
            } else if (isShowBuyNowCta) {
                key = hasPrice ? 'ppv_buy_now_price' : 'ppv_buy_now';
            } else if (isRewind) {
                key = !isSubscribed && hasPrice ? 'ppv_replay_price' : 'ppv_replay';
            }

            return hasPrice ? __(key, { amount: Number(price), currency }) : __(key);
        }

        if (shouldShowRentButton) {
            return promotion?.price ? tvodRentNowBtnText : __('tvod_rent_now');
        }

        return __(`play_now`);
    };

    const getButtonType = () => {
        if (shouldShowRentButton) return ButtonTypes.IsTVODItem;
        if (promotion?.promoType === 'EPISODE') return ButtonTypes.EpisodeItem;
        return ButtonTypes.VodFeaturedItem;
    };

    const buttonLabel = getButtonLabel();
    const showPlayIcon = !isRoute && !shouldShowRentButton;

    return (
        <PlayVideoButton
            buttonType={getButtonType()}
            item={promotion}
            componentType={COMPONENT_TYPES.FEATURED_SLIDER}
            componentName={name}
            testId={shouldShowRentButton ? 'rent-button' : 'play-video'}
            variant="button"
            className='play-video'
        >
            {shouldShowRentButton && promotion?.price ? (
                <span dangerouslySetInnerHTML={{ __html: buttonLabel }} />
            ) : (
                buttonLabel
            )}
            {isLocked ? <Icon type="lock" /> : showPlayIcon && <Icon type="play" />}
        </PlayVideoButton>
    );
};

const Icon = ({ type }) => {
    const language = useLanguage();
    return <FontIcon name={type} size="smaller" md="smaller" rotate={language === 'ar' ? 'flip' : null} />;
};

export default PlayButton;
